import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetch } from "../../Util/axios_helper";

const initialState = {
  files: [],
  viewFileDataLoad: false,
};

export const getViewFileData = createAsyncThunk("", async (obj) => {
  return await fetch(`Feedback/GetFeedbackById?Id=${obj.Id}&Type=${obj.Type}`);
});

const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getViewFileData.pending, (state) => {
      state.viewFileDataLoad = false;
    });
    builder.addCase(getViewFileData.fulfilled, (state, action) => {
      const data = action.payload;
      const fileList = data.FileName.map((fileName, index) => ({
        sno: index + 1,
        FileName: fileName,
      }));
      state.files = fileList;
      state.viewFileDataLoad = true;
    });

    builder.addCase(getViewFileData.rejected, (state, action) => {
      state.files = null;
      state.viewFileDataLoad = true;
    });
  },
});

export default feedbackSlice.reducer;
